import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import Input from './Input';
import Confirm from './Confirm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from 'react-redux';
import { showOtpModal } from '../../../redux/create-actions/OtpAction';
import TungstenIcon from '@mui/icons-material/Tungsten';
import FontSize from '../../../layouts/FontSize';
import { makeStyles } from '@mui/styles';
import Color from '../../../layouts/Color';

const steps = ['Input', 'Confirmation'];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Input />;
    case 1:
      return <Confirm />;
    default:
      throw new Error('Unknown step');
  }
}

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: ' 300px',
        paddingRight: '300px'
      },
    },
    boxGroupButton: {
      [theme.breakpoints.up("xl")]: {
        display: 'flex', 
        justifyContent: 'flex-end', 
        paddingLeft: ' 300px',
        paddingRight: '300px',
      },
    },
  };
});

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const buttonSubmit = {
  mt: 3, ml: 1,
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Normal }
};
const buttonBack = { mt: 3, ml: 1, color: Color.Main };
const checkIcon = { backgroundColor: Color.Button };

export default function MainElectricBill() {
  const classes = useStyles();
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch();

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleShowOtp = () => {
    dispatch(showOtpModal())
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <Paper variant="outlined" sx={paperStyle}>
      <Grid container alignContent="center" justifyContent="space-between"  >
        <Grid item>
          <Button id="transfer" endIcon={<TungstenIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
            Electricity Bill
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography
              variant={matchDownMD ? 'h5' : 'h4'}
              marked="left" gutterBottom>Thank you for your use service.</Typography>
            <Typography
              variant={matchDownMD ? 'body2' : 'body1'}
              color=" success"
            >
              Successfully
              <CheckCircleIcon sx={checkIcon} color=" success" />
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {getStepContent(activeStep)}
            <Box className={classes.boxGroupButton}>
              {activeStep !== 0 && (
                <Button onClick={handleBack} sx={buttonBack}
                  size={matchDownMD ? 'small' : 'medium'}
                  startIcon={<ArrowBackIosIcon />}
                >
                  Back
                </Button>
              )}

              <Button
                variant="contained"
                size={matchDownMD ? 'small' : 'medium'}
                onClick={activeStep === steps.length - 1 ? handleShowOtp : handleNext}
                sx={buttonSubmit}
                endIcon={<NavigateNextIcon />}
              >
                {activeStep === steps.length - 1 ? 'Payment' : 'Confirm'}
              </Button>
            </Box>
          </React.Fragment>
        )}
      </React.Fragment>
    </Paper>
  );
}